module.exports = __webpack_public_path__ + "static/assets/9d8c83dee048441a6b4da2d330e646ca.png";